import React from 'react';
import cn from 'classnames';
import { formatRoundFixed } from '@benzinga/utils/numberUtils';

export const QuoteChangePercent: React.FC<{
  percentageChange: number;
  showBrackets?: boolean;
  positiveColor?: string;
  negativeColor?: string;
}> = ({ negativeColor = 'text-red-500', percentageChange, positiveColor = 'text-green-500', showBrackets = false }) => {
  const formattedPercent = formatRoundFixed(percentageChange, 2);
  if (!percentageChange) {
    return <span className="text-black text-base font-semibold">N/A</span>;
  }
  return (
    // Real-time value: SSR snapshot and live client value legitimately differ. Suppress
    // the hydration warning for this text node only (no rendering-logic change).
    <span
      className={cn('quote-change-percent font-semibold', {
        [`${positiveColor}`]: percentageChange > 0,
        [`${negativeColor}`]: percentageChange < 0,
      })}
      suppressHydrationWarning
    >
      {showBrackets ? `[${formattedPercent}%]` : `${formattedPercent}%`}
    </span>
  );
};
